// Base notification interface
export interface Notification {
  id: string
  userId: string
  type: NotificationType
  message: string
  metadata: NotificationMetadata
  isRead: boolean
  readAt: string | null
  createdAt: string
  updatedAt: string
}

// Notification types
export enum NotificationType {
  JD_CONTRIBUTION = 'jd_contribution',
  JD_REACTION = 'jd_reaction',
  JD_TRENDING = 'jd_trending',
  JD_INVITATION = 'jd_invitation',
}

// Metadata types for different notification types
export type NotificationMetadata =
  | JDContributionMetadata
  | JDReactionMetadata
  | JDTrendingMetadata
  | JDInvitationMetadata

export interface JDContributionMetadata {
  contributorId: string
  contributorName: string
  jobDescriptionId: string
}

export interface JDReactionMetadata {
  jobDescriptionId: string
  reactorIds: string[]
  totalReactions: number
}

export interface JDTrendingMetadata {
  jobDescriptionId: string
  rank: number
}

export interface JDInvitationMetadata {
  inviterId: string
  inviterName: string
  targetUserId: string
  targetUserName: string
  surveyId: string
}

// API response interfaces
export interface PaginatedNotificationsResponse {
  data: Notification[]
  total: number
  page: number
  limit: number
  totalPages: number
  unreadCount: number
}

export interface UnreadCountResponse {
  count: number
}

export interface MarkAsReadPayload {
  notificationIds: string[]
}

export interface SendInvitationPayload {
  targetUserId: string
  inviteeUserIds: string[]
  message?: string
}

export interface SendInvitationResponse {
  success: boolean
  invitationsSent: number
}
